import { render } from "./AssignTeamLeader.vue?vue&type=template&id=df29538a&scoped=true"
import script from "./AssignTeamLeader.vue?vue&type=script&lang=js"
export * from "./AssignTeamLeader.vue?vue&type=script&lang=js"

import "./AssignTeamLeader.vue?vue&type=style&index=0&id=df29538a&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df29538a"]])

export default __exports__